//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import intersectionWith from 'lodash/intersectionWith';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultStatus() {
      return this.isSearching ? 'all' : 'current';
    },
    filters() {
      const filters = this.value;
      const labels = [];
      let label;

      if (filters.marketplace === false) {
        labels.push({
          type: 'AppSumo Select',
          label: 'Select only',
          handler: () => this.change('marketplace', null),
        });
      }

      if (filters.bf === true) {
        labels.push({
          type: 'Black Friday',
          label: 'Black Friday only',
          handler: () => this.change('bf', null),
        });
      }

      if (filters.sumoday === true) {
        labels.push({
          type: 'Sumo Day',
          label: 'Sumo Day only',
          handler: () => this.change('sumoday', null),
        });
      }

      if (filters.plan_type !== 'all') {
        switch (filters.plan_type) {
          case 'lifetime-deal': label = 'Lifetime deal'; break;
          case 'limited-license': label = 'Annual'; break;
          case 'freebie': label = 'Freebie'; break;
          case 'subscription': label = 'Subscription'; break;
          case 'digital-download': label = 'Digital download'; break;
          default: label = null; break;
        }

        if (label) {
          labels.push({ type: 'Plan type', label, handler: () => this.change('plan_type', 'all') });
        }
      }

      const { defaultStatus } = this;
      if (filters.status !== defaultStatus) {
        switch (filters.status) {
          case 'ending': label = 'Ending soon'; break;
          case 'expired': label = 'Unavailable'; break;
          case 'all': label = 'All'; break;
          case 'current': label = 'Current'; break;
          default: label = null; break;
        }

        if (label) {
          labels.push({ type: 'Status', label, handler: () => this.change('status', defaultStatus) });
        }
      }

      if (filters.average_rating > 0 && filters.average_rating < 5) {
        labels.push({ type: 'Avg rating', label: `${filters.average_rating} and up`, handler: () => this.change('average_rating', null) });
      }

      label = null;
      if (filters.price_range?.type === 'free') {
        label = 'Free';
      } else if (filters.price_range?.type === 'custom' && (filters.price_range?.price_from || filters.price_range?.price_to)) {
        if (filters.price_range?.price_from && filters.price_range?.price_to) {
          label = `$${filters.price_range.price_from} - $${filters.price_range?.price_to}`;
        } else if (filters.price_range.price_from) {
          label = `$${filters.price_range.price_from} -`;
        } else if (filters.price_range.price_to) {
          label = `$${filters.price_range.price_to}`;
        }
      }

      if (label) {
        labels.push({ type: 'Price', label, handler: () => this.change('price_range', { type: 'custom' }) });
      }

      if (Object.keys(filters.attributes).length > 0) {
        Object.keys(filters.attributes).forEach((key) => {
          if (['group', 'category', 'subcategory'].includes(key)) return;
          const value = filters.attributes[key];
          const attrib = this.$store.state.browse.attributes.find((a) => a.slug === key);

          if (!attrib) return;

          if (attrib.type === 'enumeration') {
            if (attrib.type_options.multiple === true) {
              const options = intersectionWith(
                attrib.type_options.options,
                value,
                (a, b) => a.value === b,
              );

              options.forEach((option) => {
                labels.push({
                  type: attrib.name,
                  label: option.name,
                  handler: () => this.removeEnumerationOption(key, option.value),
                });
              });
            } else {
              const option = attrib.type_options.options.find((o) => o.value === value);

              if (option) {
                labels.push({
                  type: attrib.name,
                  label: option.name,
                  handler: () => this.changeAttr(key, undefined),
                });
              }
            }
          } else if (attrib.type === 'boolean' && value === true) {
            labels.push({
              type: attrib.name,
              label: `${attrib.name} only`,
              handler: () => this.changeAttr(key, undefined),
            });
          }
        });
      }

      return labels;
    },
  },
  methods: {
    change(key, value) {
      // deep clone
      const filters = cloneDeep(this.value);
      set(filters, key, value);
      this.$emit('input', filters);
    },
    changeAttr(key, value) {
      const attributes = { ...this.value.attributes };
      if (typeof value !== 'undefined') {
        attributes[key] = value;
      } else {
        delete attributes[key];
      }
      this.change('attributes', attributes);
    },
    removeEnumerationOption(key, value) {
      const attributes = { ...this.value.attributes };

      if (typeof value !== 'undefined') {
        attributes[key] = attributes[key].filter((o) => o !== value);
        if (attributes[key].length === 0) {
          delete attributes[key];
        }
      }
      this.change('attributes', attributes);
    },
    clear() {
      // restore defaults
      const filters = {
        categories: [],
        average_rating: null,
        marketplace: null,
        bf: null,
        sumoday: null,
        plan_type: 'all',
        status: this.defaultStatus,
        price_range: {
          type: 'custom',
        },
        attributes: {},
      };

      if (this.value.attributes) {
        ['group', 'category', 'subcategory'].forEach((key) => {
          if (this.value.attributes[key]) {
            filters.attributes[key] = this.value.attributes[key];
          }
        });
      }

      this.$emit('input', {
        ...this.value,
        ...filters,
      });
      this.$emit('clear');
    },
  },
};
